export default __webpack_public_path__ + "static/media/289.774ab586.png";